/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createFavoriteListFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeAddItemToListRequest, serializeFavoriteList, type AddItemToListRequest, type ErrorResponse, type FavoriteList, type InternalErrorResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type WithSkuItemRequestBuilder, WithSkuItemRequestBuilderNavigationMetadata, WithSkuItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/favorites/{customerNumber-id}/{favoriteListId}/items
 */
export interface ItemsRequestBuilder extends BaseRequestBuilder<ItemsRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.favorites.item.item.items.item collection
     * @param sku SKU of the line to drop. Matched without regard to case; it must be on the list.
     * @returns {WithSkuItemRequestBuilder}
     */
     bySku(sku: string) : WithSkuItemRequestBuilder;
    /**
     * Adds one SKU to the list and returns the whole list back. A SKU the list already holds is rejected with a 400 — the quantity is not increased and the existing line is left as it was, so re-sending an add is not a way to top a line up. Change an existing line with PUT /api/favorites/{customerNumber}/{favoriteListId}/items/{sku}/quantity instead. SKUs are matched without regard to case. The SKU and product name are stored exactly as sent and are not checked against the product catalog, so a list can hold a SKU that is no longer sold.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FavoriteList>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: AddItemToListRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FavoriteList | undefined>;
    /**
     * Adds one SKU to the list and returns the whole list back. A SKU the list already holds is rejected with a 400 — the quantity is not increased and the existing line is left as it was, so re-sending an add is not a way to top a line up. Change an existing line with PUT /api/favorites/{customerNumber}/{favoriteListId}/items/{sku}/quantity instead. SKUs are matched without regard to case. The SKU and product name are stored exactly as sent and are not checked against the product catalog, so a list can hold a SKU that is no longer sold.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AddItemToListRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ItemsRequestBuilderUriTemplate = "{+baseurl}/api/favorites/{customerNumber%2Did}/{favoriteListId}/items";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ItemsRequestBuilderNavigationMetadata: Record<Exclude<keyof ItemsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    bySku: {
        requestsMetadata: WithSkuItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithSkuItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["sku"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ItemsRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ItemsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFavoriteListFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAddItemToListRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
